export default class {
  private GAParams: any;

  private readonly GAObject: any;

  private readonly window: any;

  constructor(window, GoogleAnalyticsObject) {
    this.window = window;
    this.GAObject = GoogleAnalyticsObject;
    this.GAParams = null;
  }

  getSessionParam() {
    if (this.GAObject && this.window[this.GAObject]) {
      try {
        const trackers = this.window[this.GAObject].getAll() || [];

        for (let i = 0; !this.GAParams && i < trackers.length; i += 1) {
          this.GAParams = trackers[i].get('linkerParam') || this.GAParams;
        }
      } catch (error) {
        this.window.console.error(error);
      }
    }

    return this.GAParams;
  }
}
